import { field, getLocationCountries } from "../../helpers";
import { clinicalTrialsTheme } from "../themes";

const clinicalTrialsConfig = {
  label: "Clinical Trials",
  theme: clinicalTrialsTheme,
  summary: {
    primary: field("Trial title", [
      "brief_title",
      "briefTitle",
      "official_title",
      "officialTitle",
      "title",
    ]),
    secondary: field("Identifier", ["nct_id", "nctId"], { kind: "id" }),
    columns: [
      field("Sponsor", ["lead_sponsor", "organization.name"], {
        className: "hidden lg:block flex-[1.55] min-w-[10rem]",
      }),
      field("Phase", ["phase"], {
        className: "hidden md:block flex-[0.85] min-w-[6rem]",
        kind: "accent",
      }),
      field("Start", ["start_date", "first_posted_date"], {
        className: "hidden md:block flex-[0.9] min-w-[6rem]",
      }),
    ],
  },
  detail: {
    meta: [
      field("NCT ID", ["nct_id"], { kind: "id" }),
      field("Phase", ["phase"], { kind: "accent" }),
      field("Trial Status", ["overall_status"], { kind: "status" }),
    ],
    sections: [
      {
        title: "Sponsor",
        fields: [
          field("Lead sponsor", ["lead_sponsor", "organization.name"]),
          field("Collaborators", ["collaborators", "collaborator"]),
        ],
      },
      {
        title: "Study",
        fields: [
          field("Official title", ["official_title"]),
          field("Summary", ["summary"]),
          field("Conditions", ["conditions"], {}),
          field("Interventions", ["interventions"]),
          field("Study type", ["study_type"]),
          field("Enrollment", ["enrollment", "enrollment_count"]),
          field("Primary outcome", ["primary_outcomes"]),
        ],
      },
      {
        title: "Timeline",
        fields: [
          field("Start date", ["start_date", "first_posted_date"]),
          field("Primary completion", ["primary_completion_date"]),
          field("Last Update Posted Date", ["last_update_posted_date"]),
        ],
      },
      {
        title: "Sites",
        fields: [
          field("Locations", ["locations"], {
            formatValue: getLocationCountries,
            kind: "multi-badge",
            itemKind: "accent",
          }),
        ],
      },
      {
        title: "Other Identifiers",
        includeRemainingFields: true,
      },
    ],
    links: [
      {
        label: "ClinicalTrials.gov",
        buildHref: (record, value) =>
          value ? `https://clinicaltrials.gov/study/${value}` : "",
        sources: ["nct_id"],
        valueLabel: "View study record",
      },
    ],
  },
};

export default clinicalTrialsConfig;
